import {PixiObject} from "../primitives/pixi-object";
import {ImageDrawable} from "./image.pixi";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {Graphics} from "pixi.js";
import {DRect} from "../../../primitives/drawable-rect";
import {Vector2} from "three";
import {render} from "katex";


export class TouchFollower extends PixiObject {
    lastTouchLocation: Vector2 = new Vector2(0,0)
    override config = {
        render: true
    }

    constructor(config?: {
        id?: string,
        render: boolean
    }) {
        super(config);
        this.config = config;
        if (this.config.render) {
            const graphics = new Graphics({});
            const rect = new DRect({
                left: 0,
                top: 0,
                right: 10,
                bottom: 10,
                roundness: 5,
                colour: "#ffffff",
            });
            rect.render(graphics);
            this.sprite.addChild(graphics);
        }
    }

    moveTo(target: Vector2) {
        if (this.config.render) {
            this.lastTouchLocation = target;
            this.sprite.x = target.x - 5;
            this.sprite.y = target.y - 5;
        }
    }

    override setupDefaultInteractions() {
        this.touchPrimitive.onPressed((pt) => {
            console.log('Touch follower location', this.sprite.x, " ", this.sprite.y, " ", this.id);
            this.sprite.alpha = 0.5;
            this.requestRender()
            return true; // Stop propagation
        });
        this.touchPrimitive.onReleased((pt) => {
            this.sprite.alpha = 1;
            this.requestRender()
            return true; // Stop propagation
        });
    }

}